(function () {
    var L = document.getElementById('zl-toc-label');
    var LBL = (L && L.textContent.trim()) || 'On this page';

  function init() {
    var article = document.querySelector('.t4s-article-content article');
    if (!article || document.querySelector('.zel-journal-toc')) return;
    var headings = article.querySelectorAll('h2,h3');
    if (!article.querySelector('h2')) return;
    var TOC_LABEL = ({de: 'Auf dieser Seite', es: 'En esta página', pt: 'Nesta página', it: 'In questa pagina'}[(document.documentElement.lang || 'en').toLowerCase().slice(0, 2)] || LBL);
    var nav = document.createElement('nav');
    nav.className = 'zel-journal-toc';
    nav.setAttribute('aria-label', TOC_LABEL);
    var details = document.createElement('details');
    var summary = document.createElement('summary');
    summary.textContent = TOC_LABEL;
    details.appendChild(summary);
    var list = document.createElement('ul');
    details.appendChild(list); nav.appendChild(details);
    var faq = false, parentItem = null, nested = null;
    headings.forEach(function (heading, index) {
      if (heading.tagName === 'H2') {
        faq = /faq|frequently asked/i.test(heading.textContent);
        nested = null;
      } else if (!faq) return;
      if (!heading.id) {
        var base = 'journal-' + (heading.textContent.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section');
        var id = base, count = 2;
        while (document.getElementById(id)) id = base + '-' + count++;
        heading.id = id;
      }
      heading.classList.add('zel-journal-anchor');
      var item = document.createElement('li'), link = document.createElement('a');
      link.href = '#' + encodeURIComponent(heading.id);
      link.textContent = heading.textContent.trim();
      item.appendChild(link);
      if (heading.tagName === 'H2') { list.appendChild(item); parentItem = item; }
      else {
        if (!nested) { nested = document.createElement('ul'); parentItem.appendChild(nested); }
        nested.appendChild(item);
      }
    });
    var wrapper = article.parentElement;
    var media = window.matchMedia('(min-width: 1025px)');
    function place() {
      wrapper.classList.toggle('zel-journal-layout', media.matches);
      details.open = media.matches;
      var authority = document.querySelector('.zla__authority');
      if (!media.matches && authority) authority.before(nav);
      else wrapper.appendChild(nav);
    }
    place(); media.addEventListener('change', place);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
